import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { PessoaJuridica } from "src/app/model/pessoa-juridica.model";

@Component({
    selector: 'app-pessoas-juridicas-listagem',
    templateUrl: './pessoas-juridicas-listagem.component.html',
    standalone: false
})
export class PessoasJuridicasListagemComponent {

  @Input() pessoasJuridicas: PessoaJuridica[];
  @Input() msgSemResultado: boolean = false;
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrarSubscricao: boolean = true;
  @Input() dataHoraResultado: string;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  @Output() public exportarPessoasJuridicas: EventEmitter<any> = new EventEmitter<any>();

  private nomesPessoasJuridicas: string[] = [];
  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;

  constructor(
    private activatedRoute: ActivatedRoute) {
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }


  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
    this.pessoasJuridicas = this.pessoasJuridicas.sort((a, b) => {
      if (ord.sentido == "asc") {
        return this.compara(a, b, ord.atributo);
      }
      else {
        return -1 * this.compara(a, b, ord.atributo);
      }
    });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if (typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if (_index > -1) {
      return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  btnExportarPessoasJuridicas() {
    this.exportarPessoasJuridicas.emit(null);
  }
}
